const ON_CHANGE_DEBOUNCE_TIMER = 300;

/** Aligns with `--duration-announcement-bar` (250ms) — toast before + disables */
const CART_QUANTITY_LIMIT_DISABLE_DELAY = 250;

/** Global cart error toast visible duration (ms) */
const CART_ERROR_TOAST_DURATION = 3000;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
